module.exports = __webpack_public_path__ + "img/touKui3.619b179c.png";